// src/pages/PendingActions/components/FilterSection.js
import React from 'react';
import { Card, Row, Col, Form, Button, InputGroup } from 'react-bootstrap';
import { Search, RotateCcw } from 'lucide-react';

const CONTROL_HEIGHT = '44px';

const FilterSection = ({ filters, onFilterChange, onReset }) => {
  return (
    <Card className="filter-card">
      <Card.Body>
        <Row className="g-3 align-items-end">
          
          {/* Search */}
          <Col xs={12} md={4} lg={4}>
            <Form.Group>
              <Form.Label className="filter-label">Search Patients</Form.Label>
              <InputGroup>
                <InputGroup.Text
                  style={{
                    height: CONTROL_HEIGHT,
                    backgroundColor: '#fff',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <Search size={16} className="text-muted" />
                </InputGroup.Text>

                <Form.Control
                  type="text"
                  placeholder="Search by name or NHS ID..."
                  value={filters.search}
                  onChange={(e) => onFilterChange('search', e.target.value)}
                  style={{ height: CONTROL_HEIGHT }}
                />
              </InputGroup>
            </Form.Group>
          </Col>

          {/* Report Status */}
          <Col xs={12} sm={6} md={3} lg={3}>
            <Form.Group>
              <Form.Label className="filter-label">Report Status</Form.Label>
              <Form.Select
                value={filters.reportStatus}
                onChange={(e) => onFilterChange('reportStatus', e.target.value)}
                style={{ height: CONTROL_HEIGHT }}
              >
                <option value="">All Statuses</option>
                <option value="missing">Missing</option>
                <option value="pending">Pending Upload</option>
              </Form.Select>
            </Form.Group>
          </Col>

          {/* Patient Type */}
          <Col xs={12} sm={6} md={3} lg={3}>
            <Form.Group>
              <Form.Label className="filter-label">Patient Type</Form.Label>
              <Form.Select
                value={filters.patientType}
                onChange={(e) => onFilterChange('patientType', e.target.value)}
                style={{ height: CONTROL_HEIGHT }}
              >
                <option value="">All Patients</option>
                <option value="new">New Patients</option>
                <option value="existing">Existing Patients</option>
                <option value="overdue">Overdue (Multi-Month)</option>
              </Form.Select>
            </Form.Group>
          </Col>

          {/* Reset Button */}
          <Col xs={12} sm={6} md={2} lg={2}>
            <Button
              variant="outline-primary"
              className="w-100"
              onClick={onReset}
              style={{
                height: CONTROL_HEIGHT,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <RotateCcw size={16} className="me-1" />
              Reset
            </Button>
          </Col>

        </Row>
      </Card.Body>
    </Card>
  );
};

export default FilterSection;
